import { ifAuthenticated, mustBeAdmin } from "../util/auth";

const Benefit = () => import("../components/content/benefit/benefit");
const CreateHMO = () => import("../components/content/benefit/createHmo");
const BenefitSummary = () =>
  import("../components/content/benefit/benefitSummary");
const HmoSummary = () => import("../components/content/benefit/hmoSummary");

export const benefitRoute = {
  path: "/benefits",
  component: Benefit,
  // beforeEnter: ifAuthenticated
  beforeEnter: mustBeAdmin
};

export const createHmoRoute = {
  path: "/create-hmo",
  component: CreateHMO,
  // beforeEnter: ifAuthenticated
  beforeEnter: mustBeAdmin
};

export const benefitSummaryRoute = {
  path: "/benefits-summary/:id",
  name: "benefitSummary",
  component: BenefitSummary,
  // beforeEnter: ifAuthenticated
  beforeEnter: mustBeAdmin
};

export const hmoSummaryRoute = {
  path: "/hmo-summary/:id",
  name: "hmoSummary",
  component: HmoSummary,
  // beforeEnter: ifAuthenticated
  beforeEnter: mustBeAdmin
};
